import React from 'react';
import { IconProps } from './types';

export const MenuIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill={color} d='M20.2 11H3.8v2h16.4v-2zM20.2 5H3.8v2h16.4V5zM20.2 17H3.8v2h16.4v-2z' />
    </svg>
  );
};
